import Skeleton from "react-loading-skeleton";
import { BgWrapper } from "../../../../components/wrapper/bgWrapper";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../../../utils/constants";

export const PreviewLoader = () => {
  return (
    <div className="mx-auto flex flex-col gap-3 md:flex-row md:gap-10 xl:max-w-[1070px]">
      <div className="flex w-full flex-col gap-3 md:max-w-[500px]">
        <BgWrapper className="h-[300px] w-full md:h-[472px]">
          <Skeleton
            count={1}
            width={"100%"}
            height={"100%"}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
            className="rounded-lg"
          />
        </BgWrapper>
      </div>

      <div className="flex flex-1 flex-col gap-3">
        <BgWrapper className="flex w-full flex-col gap-1">
          <Skeleton
            count={1}
            width={"90%"}
            height={"50px"}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
            className="rounded-lg"
          />
          <Skeleton
            count={1}
            width={"150px"}
            height={"20px"}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
            className="rounded-lg"
          />
          <Skeleton
            count={1}
            width={"250px"}
            height={"20px"}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
            className="rounded-lg"
          />
        </BgWrapper>
        <BgWrapper className="flex w-full flex-col gap-2">
          <Skeleton
            count={1}
            width={"70%"}
            height={"40px"}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
            className="rounded-lg"
          />
          <Skeleton
            count={1}
            width={"80%"}
            height={"40px"}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
            className="rounded-lg"
          />
          <Skeleton
            count={1}
            width={"90%"}
            height={"40px"}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
            className="rounded-lg"
          />
          <Skeleton
            count={1}
            width={"100%"}
            height={"40px"}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
            className="rounded-lg"
          />
        </BgWrapper>
      </div>
    </div>
  );
};
